import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    saveSettings(_, settings) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/userSettings/saveSettings",
            method: "POST",
            data: {
              settings: settings
            }
          })
          .then(resolve)
          .catch(reject);
      });
    },
    fetchSettings(_, userId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/userSettings/settings/" + userId,
            method: "GET"
          })
          .then(resolve)
          .catch(reject);
      });
    }
  },
  modules: {},
  getters: {}
};
